<template>
    <div class="invoice-preview">
        <InvoiceHeader
            :invoice="invoice"
            :contact-id="getContactId"
            :company-profile="companyProfile"
            :app-sales-info="appSalesInfo"
        >
            <slot />
        </InvoiceHeader>

        <InvoiceLineItems
            :invoice="invoice"
        />

        <InvoiceTotals :invoice="invoice" :app-sales-info="appSalesInfo" />

        <OrderTerms
            :order="invoice"
            type="Invoice"
        />

        <InvoicePayments
            :invoice="invoice"
            :company-profile="companyProfile"
        />

        <div class="mobile">
            <slot />

            <div class="secure-transaction">
                <DsIcon name="lock-locked-fill" />
                <span>{{ $t('MoneyLib.secureTransaction') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { DsIcon } from '@infusionsoft/design-system';
import InvoiceHeader from './InvoiceHeader.vue';
import InvoiceLineItems from './InvoiceLineItems.vue';
import InvoicePayments from './InvoicePayments.vue';
import InvoiceTotals from './InvoiceTotals.vue';
import OrderTerms from '../order/OrderTerms.vue';

export default {
    components: {
        DsIcon,
        InvoiceHeader,
        InvoiceLineItems,
        InvoiceTotals,
        OrderTerms,
        InvoicePayments,
    },

    props: {
        companyProfile: Object,
        invoice: Object,
        appSalesInfo: {
            type: Object,
            default: () => ({}),
        },
    },

    computed: {
        getContactId() {
            return Number(this.invoice?.contact?.contactId);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common';

.secure-transaction {
    --icon-size: #{px-to-rem(12px)};
    --icon-margin: #{0 $spacing-050 (-$spacing-025) 0};
}

.mobile {
    margin: 0 $spacing-200 $spacing-200;
    display: none;

    .secure-transaction {
        text-align: center;
    }
}

@media($small) {
    .mobile {
        display: block;
    }
}

@media print {
    .mobile {
        display: none;
    }
}
</style>
